import { reportsApi } from "common/api/reports";
import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command, GetCommandsProps } from "common/app/command-palette/types";
import { canView } from "x/layout/navigation/functions";

export class ReportsProvider extends BaseCommandProvider {
  private commands: Command[] | null = null;
  private isLoading = false;

  async getCommands({ context }: GetCommandsProps): Promise<Command[]> {
    if (this.commands !== null) {
      return this.commands;
    }

    if (this.isLoading) {
      return [];
    }

    if (!canView(context, "Reports")) {
      this.commands = [];
      return this.commands;
    }

    this.isLoading = true;

    try {
      const { apiCall, uiFormat, entities } = context;
      const { culture } = uiFormat;

      const reports = await reportsApi(apiCall, culture, entities).list();

      this.commands = reports.map(
        (report): Command => ({
          id: `report:${report.id}`,
          label: report.labels[culture].name ?? report.name,
          icon: "fa-table",
          link: `#/${context.site.name}/Reports/${report.id}`,
          category: "report",
        }),
      );

      return this.commands;
    } catch (error) {
      return [];
    } finally {
      this.isLoading = false;
    }
  }

  dispose() {
    this.commands = null;
    this.isLoading = false;
  }
}
